<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('sendMessage') >= 0,
        'last-active': opened.indexOf('sendMessage') == opened.length - 1,
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div
          class="atom-back atom-back--gray"
          @click="toggleMessageConfirmation()"
        >
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
        <button v-if="devices.every(device => device?.partnerId === 3)" class="btn btn-primary" @click="sendMessage()">
          {{ $t("odeslat") }}
        </button>
        <div class="text-danger" v-else>{{ $t("CANT_SEND_MESSAGE") }}</div>
      </div>
      <div class="side-box__title">
        <h2 v-if="devices">
          {{ $t("PoslatZpravuDo") }}
          <span v-if="devices.length > 1">{{ devices.length }} </span
          >{{ $t("zarizeniPocet") }}
        </h2>
        <h3 v-if="devices">
          <span v-if="devices.length == 1">{{
            devices[0]?.custDeviceName
          }}</span>
        </h3>
      </div>
      <div class="side-box__content">
        <div class="d-flex side-box__row align-items-start mt-4">
          <span class="side-box__content__label mt-3"
            ><div class="mt-1">{{ $t("port") }}</div></span
          >
          <div class="w-100 side-box__content__input ml-3">
            <div class="d-flex">
              <div class="custom-control__custom-input mt-2">
                <input
                  v-model="message.port"
                  type="number"
                  min="1"
                  max="255"
                  class="w-100"
                  placeholder=""
                  autofocus
                />
              </div>
            </div>

            <div v-if="errors.port" class="text-danger">
              {{ errors.port }}
            </div>
          </div>
        </div>

        <div class="d-flex side-box__row align-items-start mt-4">
          <span class="side-box__content__label mt-5"
            ><div class="mt-1">{{ $t("payload") }}</div></span
          >
          <div class="w-100 side-box__content__input ml-3 border-top pt-4">
            <div class="d-flex">
              <div class="custom-control__custom-input mt-2">
                <input
                  v-model="message.data"
                  type="text"
                  class="w-100"
                  placeholder=""
                  autofocus
                />
              </div>
              <div class="d-flex align-items-center ml-3">
                <img src="@/assets/icons/check-green.svg" class="mr-2" />
                <span>
                  {{ b }}
                  {{
                    $filters.inflection(
                      b,
                      $t("inflection_1_bajt"),
                      $t("inflection_2_4_bajt"),
                      $t("inflection_5_bajt")
                    )
                  }}
                </span>
              </div>
            </div>

            <div v-if="errors.payload" class="text-danger">
              {{ errors.payload }}
            </div>
          </div>
        </div>
        <div class="side-box__row mt-4 pb-4 d-flex align-items-center">
          <span class="side-box__content__label mt-sm-5" />
          <div
            class="w-100 side-box__content__input d-flex align-items-center pointer border-top ml-3 pt-4"
            @click="flushQueue = flushQueue ? false : true"
          >
            <div
              class="custom-control custom-control--checkbox"
              :class="{ checked: flushQueue }"
            >
              <input type="checkbox" class="custom-control-input" />
            </div>
            {{ $t("predOdeslanimSmazatFrontu") }}
          </div>
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedMessageSendConfirmation"
      :text="'chceteOdeslatZpravu'"
      @yes="sendMessage()"
      @no="closeBox()"
      @close="toggleMessageConfirmation"
    />
    <confirmation-modal
      :opened="openedSuccess"
      :text="'zpravaOdeslana'"
      @yes="closeBox()"
      @close="openedSuccess = false"
    />
    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="openedError = false"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ConfirmationModal from "@/components/confirmations/info.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
export default {
  components: {
    "save-confirmation-modal": SaveConfirmationModal,
    "confirmation-modal": ConfirmationModal,
    "error-modal": ErrorModal,
  },
  props: {
    devices: Array,
    opened: Array,
  },
  data() {
    return {
      openedMessageSendConfirmation: false,
      errors: {
        payload: "",
        port: "",
        device: "",
        group: "",
      },
      message: {
        cmd: "tx",
        port: 1,
        data: "",
        EUI: "",
        confirmed: true,
      },
      portOpened: false,
      flushQueue: false,
      errorsToTranslate: [],
      openedError: false,
      openedSuccess: false,
    }
  },
  computed: {
    b() {
      return Math.ceil(this.message.data.length / 2)
    },
  },
  watch: {
    opened() {
      if (this.opened.indexOf("sendMessage") > -1) {
        this.message = {
          cmd: "tx",
          port: 1,
          data: "",
          EUI: "",
          confirmed: true,
        }
      }
    },
  },
  mounted() {},
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.emptyValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    sendMessage() {
      /** port and payload validation */
      this.errors = {}
      var errorFound = false
      if (
        this.message.port > 255 ||
        this.message.port < 1 ||
        !this.message.port
      ) {
        this.errors.port = this.$t("SendMessagePortError")
        errorFound = true
      }
      if (!this.message.data) {
        this.errors.payload = this.$t("SendMessagePayloadErrorEmpty")
        errorFound = true
      } else if (!this.message.data.match(/^[a-f0-9]*$/i)) {
        this.errors.payload = this.$t("SendMessagePayloadError")
        errorFound = true
      } else if (this.message.data.length % 2 != 0) {
        this.errors.payload = this.$t("SendMessagePayloadErrorModulo")
        errorFound = true
      }

      if (!errorFound) {
        this.$store.commit(
          "modals/setWaitingLoader",
          this.$t("Odesílám data, čekejte prosím...")
        )

        this.errorsToTranslate = []
        let promises = []
        this.devices.forEach((device) => {
          this.message.EUI = device.deviceId

          let mess = Object.assign({}, this.message)
          mess.EUI = String(device.deviceId)

          if (this.flushQueue) {
            promises.push(
              axios
                .post(
                  process.env.VUE_APP_API +
                    "/lora/devices/" +
                    device.deviceId +
                    "/flush-queue",
                  {}
                )
                .then(() => {
                  axios
                    .post(
                      process.env.VUE_APP_API +
                        "/lora/devices/" +
                        device.deviceId +
                        "/down/messages",
                      mess,
                      {}
                    )
                    .then(() => {
                      this.$store.commit("modals/setWaitingLoader", "")
                      this.openedSuccess = true
                    })
                    .catch((err) => {
                      this.$store.commit("modals/setWaitingLoader", "")
                      this.errorsToTranslate.push(err.data)
                    })
                })
                .catch(() => {
                  this.$store.commit("modals/setWaitingLoader", "")
                })
            )
          } else {
            promises.push(
              axios
                .post(
                  process.env.VUE_APP_API +
                    "/lora/devices/" +
                    device.deviceId +
                    "/down/messages",
                  mess,
                  {}
                )
                .then(() => {
                  this.$store.commit("modals/setWaitingLoader", "")
                  this.openedSuccess = true
                  //this.$emit('reloadMessages', true);
                  //this.$emit('closeBox');
                })
                .catch((err) => {
                  this.$store.commit("modals/setWaitingLoader", "")
                  this.errorsToTranslate.push(err.data)
                })
            )
          }
        })
        Promise.all(promises).then(() => {
          if (this.errorsToTranslate.length > 0) {
            this.openedError = true
          }
          this.$emit("reloadMessages", true)
          //this.$emit("closeBox");
        })
      }
    },
    toggleMessageConfirmation() {
      this.openedMessageSendConfirmation = this.openedMessageSendConfirmation
        ? false
        : true
    },
    emptyValues() {
      this.message = {
        cmd: "tx",
        port: 1,
        data: "",
        EUI: "",
        confirmed: true,
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
